import { Api } from '@/services/GeneratedApi';
import AxiosConfiguration from './AxiosConfiguration';
import axios, { AxiosInstance } from 'axios';

export default class ApiConfiguration {
  public static api = () => new Api(ApiConfiguration.configure(axios));
  public static apiWithErrorPage = () => new Api(ApiConfiguration.configure(AxiosConfiguration.axiosWithErrorPage));
  public static apiWithoutNotification = () => new Api(ApiConfiguration.configure(AxiosConfiguration.axiosWithoutNotification));

  private static configure(instance: AxiosInstance): AxiosInstance {
    const configuredInstance = axios.create({ ...instance.defaults, baseURL: process.env.BASE_URL });
    configuredInstance.interceptors.response = instance.interceptors.response;
    return configuredInstance;
  }
}
